/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PersonUserRoleIds {
	Perusrooli = 1,
	Elinkeino = 2,
	AlkavatYrittajat = 3,
	Hakemus = 4,
	Kunta = 5,
	Nuori = 6,
	Oppilaitos = 7,
	Tyollisyys = 8,
	Kotoutuminen = -9,
	Hanke = -10,
	LeaderGroup = -11,
	Sijoittumispalvelut = -12,
}
